import styled from '@emotion/styled';

import { IconButton } from '@web/ui/components';
import {
  DiscordIcon,
  GiphyIcon,
  InstagramIcon,
  TelegramIcon,
  TwitterIcon,
} from '@web/ui/icons';

import {
  DISCORD_LINK,
  GIPHY_LINK,
  INSTAGRAM_LINK,
  TELEGRAM_LINK,
  TWITTER_LINK,
} from '../const';

const Socials = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: ${({ theme }) => theme.spacing('1000')};
  color: ${({ theme }) => theme.color.onBackground};
`;

export const SocialLinks = () => (
  <Socials>
    <IconButton href={TWITTER_LINK} rel="noreferrer" target="_blank">
      <TwitterIcon size="1250" />
    </IconButton>
    <IconButton href={DISCORD_LINK} rel="noreferrer" target="_blank">
      <DiscordIcon size="1250" />
    </IconButton>
    <IconButton href={TELEGRAM_LINK} rel="noreferrer" target="_blank">
      <TelegramIcon size="1250" />
    </IconButton>
    <IconButton href={INSTAGRAM_LINK} rel="noreferrer" target="_blank">
      <InstagramIcon size="1250" />
    </IconButton>
    <IconButton href={GIPHY_LINK} rel="noreferrer" target="_blank">
      <GiphyIcon size="1250" />
    </IconButton>
  </Socials>
);
